module.exports = __webpack_public_path__ + "static/media/green_chip.abc70684.png";